<p-dialog header="Search TAs"
          [visible]="visible()"
          (visibleChange)="visible.set($event)"
          [modal]="true"
          [dismissableMask]="true"
          [closeOnEscape]="true"
          [focusOnShow]="false"
          [draggable]="false"
          [resizable]="false"
          [style]="{width: '1000px', maxWidth: 'calc(100vw - 32px)', height: '90vh', minHeight: '420px'}"
          [contentStyle]="{display: 'flex', flexDirection: 'column', flex: '1', minHeight: '0'}"
          (onShow)="onShow()">
  <div data-testid="quick-search">
    <submission-search-bar [(advancedEnabled)]="advancedEnabled"
                           [(basicSearchStr)]="searchStr"
                           [advancedSearchParameters]="advancedSearchParameters"
                           [loading]="loading()"
                           [bordered]="true"
                           (search)="runSearch()"
                           (clear)="clear()"/>
  </div>

  @if (hasSearched() && results().length) {
    <div class="flex items-center gap-3 pt-3">
      <div class="px-2 text-sm font-semibold font-['Roboto_Condensed'] text-slate-500">
        Search Results
      </div>
      <div class="flex-1"></div>
      <div class="text-xs text-slate-500">
        Showing {{ results().length }} of {{ totalCount() }} results
      </div>
    </div>
    <div class="mt-2 flex-1 min-h-0 rounded-lg border-[1px] border-surface-300 overflow-y-auto">
      <p-table [value]="results()"
               stripedRows
               [tableStyle]="{'min-width': '50rem'}"
               sortField="taNumber"
               [sortOrder]="-1"
               class="rounded-lg">
        <ng-template #header>
          <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed']">
            <th class="rounded-tl-lg w-8"></th>
            <th class="w-6" style="padding-left: 0; padding-right: 4px;"></th>
            <th>TA Number</th>
            <th>Status</th>
            <th>Primary Traveller</th>
            <th>No. of Travellers</th>
            <th>Project Code</th>
            <th>Start</th>
            <th>End</th>
            <th class="rounded-tr-lg w-8"></th>
          </tr>
        </ng-template>
        <ng-template #body let-taSubmission let-rowIndex="rowIndex">
          <tr class="text-xs font-normal font-['Roboto_Condensed'] hover:cursor-pointer" (click)="selectedId.set(taSubmission.id)" (dblclick)="open(taSubmission)">
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId(), 'rounded-bl-lg': rowIndex === results().length - 1}">
              <prepaid-indicator [taDetails]="taSubmission"></prepaid-indicator>
            </td>
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId()}" style="padding-left: 0; padding-right: 4px;">
              <attachment-indicator [taDetails]="taSubmission"></attachment-indicator>
            </td>
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId()}">
              <button class="text-primary-500 hover:underline font-semibold cursor-pointer"
                      (click)="open(taSubmission); $event.stopPropagation()">
                {{ taSubmission.taNumber }}
              </button>
            </td>
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId()}">
              <p-chip>
                <div class="whitespace-nowrap">{{ toTAStatusText(taSubmission.status) }}</div>
              </p-chip>
            </td>
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId()}">
              <div class="flex gap-1 items-center">
                @if (taSubmission.travellerCount > 1) {
                  <i class="fa-solid fa-users"></i>
                } @else {
                  <i class="fa-solid fa-user"></i>
                }
                <span class="text-nowrap">{{ taSubmission.primaryTraveller?.details?.name }}</span>
              </div>
            </td>
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId()}">{{ taSubmission.travellerCount }}</td>
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId()}">{{ taSubmission.projectCode }}</td>
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId()}">{{ taSubmission.startDate | date:'dd/MM/yy' }}</td>
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId()}">{{ taSubmission.endDate | date:'dd/MM/yy' }}</td>
            <td [ngClass]="{'bg-primary-50': taSubmission.id === selectedId(), 'rounded-br-lg': rowIndex === results().length - 1}">
              <ta-comment-count [count]="taSubmission.commentCount"></ta-comment-count>
            </td>
          </tr>
        </ng-template>
      </p-table>

      @if (canLoadMore()) {
        <div class="flex items-center justify-center gap-3 py-3">
          <p-button label="Load More"
                    severity="secondary"
                    size="small"
                    icon="fa fa-arrow-down"
                    [disabled]="loading()"
                    (onClick)="loadMore()">
          </p-button>
        </div>
      }
    </div>
  } @else if (hasSearched()) {
    <div class="px-2 pt-4 text-slate-500 text-sm font-normal font-['Inter'] leading-6"><i>Your search returned no results</i></div>
  } @else {
    <div class="px-2 pt-4 text-slate-500 text-sm font-normal font-['Inter'] leading-6">Use the search above to find TA submissions.</div>
  }
</p-dialog>
